import api from "../api/axios";

const settingsService = {
  getTenantSettings: () => api.get("/settings/get-tenant-settings"),
  saveTenantSetting: (data) => api.post("/settings/save-tenant-setting", data),
};

export default settingsService;
